import React from 'react'
import get from 'lodash.get'
import parse from 'html-react-parser'

export type TranslationType =
  | string
  | React.DetailedReactHTMLElement<{}, HTMLElement>
  | Array<React.DetailedReactHTMLElement<{}, HTMLElement>>
type TranslationContextType = {
  translations?: any
  translate?: (string, object?) => TranslationType
  translateIfAble?: (string, object?) => TranslationType
  translateLocale?: () => string
}
const TranslationContext = React.createContext<TranslationContextType>({})

type TranslationProviderProps = {
  localeStrings: any
  children: any
}
const TranslationProvider: React.FC<TranslationProviderProps> = ({ children, localeStrings }) => {
  function translate(path, substitutions?) {
    let result = get(localeStrings, path, null) || get(localeStrings, `enLocaleStrings.${path}`, '')
    if (typeof result === 'string') {
      if (substitutions) {
        for (const sub in substitutions) {
          result = result.replace(new RegExp(`__${sub}__`, 'g'), substitutions[sub])
        }
      }
      return parse(result) //using parse for now because of this https://github.com/facebook/react/issues/12014
    }
  }

  function translateIfAble(path, substitutions?) {
    try {
      const translation = translate(path, substitutions)
      if (typeof translation === 'string') return translation
      else return path
    } catch (error) {
      return path
    }
  }

  function translateLocale() {
    return get(localeStrings, `locales.${localeStrings.currentLocale}`, '')
  }

  return (
    <TranslationContext.Provider
      value={{
        translations: localeStrings,
        translate,
        translateIfAble,
        translateLocale
      }}
    >
      {children}
    </TranslationContext.Provider>
  )
}

export { TranslationProvider, TranslationContext }
